import { TENANTS } from '../tenants/constants';

import { ADELPHI_MASH_SUBSTEPS_INFO } from '#models/business/mashStep/constants';
import { ADELPHI_WASH_SUBSTEPS_INFO } from '#models/business/washStep/constants';
import { ADELPHI_SPIRIT_SUBSTEPS_INFO } from '#models/business/spiritStep/constants';

export const STEPS_IDS = {
  MASH: 'MASH',
  WASH: 'WASH',
  SPIRIT: 'SPIRIT'
};

export const STEPS = {
  [STEPS_IDS.MASH]: 'mash',
  [STEPS_IDS.WASH]: 'wash',
  [STEPS_IDS.SPIRIT]: 'spirit'
};

export const STEPS_STATUS_IDS = Object.values(STEPS_IDS).reduce(
  (prevValues, actValue) => ({
    ...prevValues,
    [actValue]: `${STEPS[actValue]}Status`
  }),
  {}
);

export const SUBSTEPS_INFO_BY_TENANT = {
  [TENANTS.ADELPHI]: {
    [STEPS.MASH]: ADELPHI_MASH_SUBSTEPS_INFO,
    [STEPS.WASH]: ADELPHI_WASH_SUBSTEPS_INFO,
    [STEPS.SPIRIT]: ADELPHI_SPIRIT_SUBSTEPS_INFO
  }
};

export const SUBSTEPS_INFO = SUBSTEPS_INFO_BY_TENANT[process.env.REACT_APP_TENANT];
